import { number, object } from 'yup'

export const tournamentConditionsSchema = object({
  minBet: number().required(),
  minRound: number().required(),
})
